// extracted by mini-css-extract-plugin
export default {"checkbox":"MGInputCheckbox_checkbox__matoI","input":"MGInputCheckbox_input__YIKFP","visual":"MGInputCheckbox_visual__iVr37","icon":"MGInputCheckbox_icon__i69ST"};